import { openDrawer } from "@/src/components/dialogs";
import { Input } from "@/src/components/universalInput";
import {
  RefAnswer,
  Reference,
  Sample,
  sampleLocationCategories,
  sampleLocations,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { useState } from "react";
import { ReferenceFieldsForm } from "../fields/referenceFieldsForm";
import { MyDynamicSelect } from "@/src/components/dynamicSelect";
import { getItemId, getUserId } from "@/src/utils/utils";
import { USER } from "@/src/data/globalVariables";

export function AnapathSampleForm({
  current,
  isSimplified,
  onChange,
}: {
  current?: Sample;
  isSimplified?: boolean;
  onChange: (newValue: Sample) => void;
}) {
  let [data, setData] = useState(current || ({} as Sample));
  function setNewValue(newValue: Sample) {
    setData(newValue);
    onChange(newValue);
  }

  function getLocationOptions() {
    if (data.locationCategory == null) return [];
    return Object.values(sampleLocations).filter(
      (location) => location.category === data.locationCategory
    );
  }

  async function loadSampleTypes() {
    return (USER.get()?.speciality?.frequentReferences?.filter(
      (item) => item?.category == "sampleType"
    ) || []) as Reference[];
  }

  function shouldShowLocationInput() {
    const reference = USER.get()?.speciality?.frequentReferences?.find(
      (item) => getItemId(item) == getItemId(data.refAnswer?.reference)
    );
    return ["frottis", "liquide", "biopsie"]?.includes(
      reference?.name?.toLowerCase() || ""
    );
  }

  return (
    <div className="grid c1 gap10">
      <Input
        name="Code barre"
        shouldFocus={true}
        value={data.barcode}
        type="text"
        placeholder="Texte libre..."
        onChange={(newValue) => {
          setNewValue({ ...data, barcode: newValue });
        }}
      />
      <MyDynamicSelect
        queryFn={loadSampleTypes()}
        queryKey={["loadSampleTypes"]}
        valueContructor={(item) => item?.id}
        nameConstructor={(item) => item?.name}
        placeholder={"Choisir un type de prélèvement"}
        name={"Type de prélèvement"}
        value={data.refAnswer?.reference?.id}
        onChange={(newValue) => {
          data.refAnswer ||= {
            creator: getUserId(),
            patient: getItemId(data.patient),
            fieldAnswers: [],
            notes: "",
            reference: null,
          };
          data.refAnswer.reference = newValue;

          setNewValue({
            ...data,
            refAnswer: { ...data.refAnswer } as RefAnswer,
          });
        }}
      />
      <Input
        name={`Nombre de flacons`}
        value={data.numberOfPieces?.toString()}
        type="select"
        options={[
          ...Array.from({ length: 10 }, (_, i) => ({
            id: (i + 1).toString(),
            name: (i + 1).toString(),
          })),
        ]}
        placeholder={"Ex: 3"}
        onChange={(newValue) => {
          setNewValue({ ...data, numberOfPieces: parseInt(newValue) });
        }}
      />
      {shouldShowLocationInput() && (
        <Input
          name={`Type`}
          value={data.locationCategory}
          type="chips"
          options={Object.values(sampleLocationCategories)}
          onChange={(newValue) => {
            setNewValue({
              ...data,
              locationCategory: newValue,
              location: null,
            });
          }}
        />
      )}
      {shouldShowLocationInput() && getLocationOptions().length > 0 && (
        <div className="fade" key={`subLocation-${data.locationCategory}`}>
          <Input
            name={`Siège`}
            type="chips"
            options={getLocationOptions()}
            value={data.location}
            onChange={(newValue) => {
              setNewValue({ ...data, location: newValue });
            }}
          />
        </div>
      )}

      <ReferenceFieldsForm
        patient={data.patient}
        currentAnswers={data.refAnswer?.fieldAnswers || []}
        item={data.parent}
        reference={data.refAnswer?.reference}
        isHorizontal={false}
        onChange={(newFieldAnswers) => {
          data.refAnswer!.fieldAnswers = newFieldAnswers;
        }}
      />

      <Input
        name="Notes"
        value={data.refAnswer?.notes}
        type="textarea"
        rows={8}
        placeholder="Texte libre..."
        onChange={(newValue) => {
          setNewValue({
            ...data,
            refAnswer: { ...data.refAnswer, notes: newValue } as RefAnswer,
          });
        }}
      />

      {/* <Input
            name="Conclusion"
            value={data.conclusion}
            type="text"
            placeholder="Texte libre..."
            onChange={(newValue) => {
              setNewValue({ ...data, conclusion: newValue });
            }}
          /> */}
    </div>
  );
}

export function openAnapathSampleForm({
  sample,
  isSimplified,
  onSave,
}: {
  sample: Sample;
  isSimplified?: boolean;
  onSave: (sample: Sample) => void;
}) {
  openDrawer({
    id: "anapathSampleForm",
    title: "Pièce / Prélèvement",
    additionalClasses: ["medium"],
    content: (
      <AnapathSampleForm
        current={sample}
        isSimplified={isSimplified}
        onChange={(newValue) => {
          sample = newValue;
        }}
      />
    ),
    onConfirm: async () => {
      sample = await apiFetch("samples", "addOne", {
        sample,
      });
      onSave(sample);
    },
  });
}
